/*
 * For an array of length N will produce N-1 pairs of its elements.
 * E.g. for [A, B, C, D] it will produce pairs [A, B], [B, C], [C, D]
 * Does not produce any pairs for arrays shorter than 2 items.
 */
function* pairsGenerator<T>(arr: T[]): Generator<[T, T], void, void> {
  if (arr.length < 2) {
    return;
  }

  for (let i = 1; i < arr.length; i++) {
    yield [arr[i - 1], arr[i]];
  }
}

export default pairsGenerator;
